import { useParams } from 'react-router-dom';
import { useYaotaiGlobalContextState } from '../contexts';

export const useInvokeAreaPrefix = ({ needSlug = true }: { needSlug?: boolean } = {}) => {
  const { aid } = useParams();
  const { currentAid } = useYaotaiGlobalContextState();

  const hasAid = currentAid || aid;

  return {
    login: hasAid ? `${needSlug ? `/` : ''}activity/${currentAid || aid}/login` : '/login',
    registration: hasAid ? `${needSlug ? `/` : ''}activity/${currentAid || aid}/registration` : '/registration',
    bindPhone: hasAid ? `${needSlug ? `/` : ''}activity/${currentAid || aid}/bind-mobile` : '/bind-mobile',
  };
};
